/**
 * Стратегії для DatePickerRange та EditorJs полів
 */

import type { IFieldConfig } from '@/Core/Contracts/UI/Form'
import type { IFieldInputStrategy } from '@/Core/Contracts/UI/IFieldInputStrategy'
import { DatePickerRangeInput } from '../Inputs/DatePickerRangeInput'
import { BaseFieldInputStrategy } from './BaseFieldInputStrategy'

/**
 * Стратегія для DatePickerRange поля
 */
export class DateRangeFieldStrategy extends BaseFieldInputStrategy implements IFieldInputStrategy {
    getType(): string {
        return 'daterange'
    }

    getInputComponent(fieldConfig: IFieldConfig): React.ComponentType<any> {
        return DatePickerRangeInput
    }

    transformInputProps(fieldConfig: IFieldConfig): Record<string, any> {
        return {
            placeholder: fieldConfig.placeholder,
            format: fieldConfig.format || 'YYYY-MM-DD',
            disabled: fieldConfig.disabled,
            ...fieldConfig.inputProps,
        }
    }
}

/**
 * Стратегія для DateTimeRange поля
 */
export class DateTimeRangeFieldStrategy extends BaseFieldInputStrategy implements IFieldInputStrategy {
    getType(): string {
        return 'datetimerange'
    }

    getInputComponent(fieldConfig: IFieldConfig): React.ComponentType<any> {
        return DatePickerRangeInput
    }

    transformInputProps(fieldConfig: IFieldConfig): Record<string, any> {
        return {
            placeholder: fieldConfig.placeholder,
            format: fieldConfig.format || 'YYYY-MM-DD HH:mm:ss',
            showTime: true,
            disabled: fieldConfig.disabled,
            ...fieldConfig.inputProps,
        }
    }
}
